import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _Form from "antd/es/form";
import React, { Component } from 'react';
import Sort from '../../common/Question/Sort';
import { OptionItem, CustomDragLayer } from '../../mobile/Question/Sort';
var FormItem = _Form.Item;
var SortPC = /*#__PURE__*/function (_Component) {
  _inherits(SortPC, _Component);
  function SortPC() {
    _classCallCheck(this, SortPC);
    return _possibleConstructorReturn(this, _getPrototypeOf(SortPC).apply(this, arguments));
  }
  _createClass(SortPC, [{
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        label = _this$props.label,
        question = _this$props.question;
      var _question$custom$sort = question.custom.sortType,
        sortType = _question$custom$sort === void 0 ? 'drag' : _question$custom$sort;
      return React.createElement(Sort, this.props, function (_ref) {
        var options = _ref.options,
          error = _ref.error,
          onChange = _ref.onChange,
          formAnswer = _ref.formAnswer,
          handleDrop = _ref.handleDrop,
          handleDragStart = _ref.handleDragStart,
          clickedOptions = _ref.clickedOptions;
        return React.createElement(FormItem, {
          label: label,
          validateStatus: error.selected || error.text ? 'error' : null,
          hasFeedback: true,
          help: error.selected || error.text,
          required: question.required
        }, React.createElement("div", {
          id: _this.props.question.id,
          className: "flex"
        }, React.createElement("div", {
          className: "flex1"
        }, React.createElement(CustomDragLayer, null), (options || []).map(function (option, index) {
          return React.createElement(OptionItem, {
            key: option.id,
            index: index,
            isFirst: index === 0,
            isLast: index === options.length - 1,
            question: question,
            option: option,
            onChange: onChange,
            formAnswer: formAnswer,
            handleDrop: handleDrop,
            handleDragStart: handleDragStart,
            sortType: sortType,
            clickedOptions: clickedOptions
          });
        }))));
      });
    }
  }]);
  return SortPC;
}(Component);
export { SortPC as default };